<!-- Floating Chatbot Trigger Bubble (Appears on Scroll & Always Accessible) -->
<div class="fixed bottom-6 right-6 z-[99999] flex flex-col items-end gap-2.5 pointer-events-auto font-sans"
    *ngIf="showTriggerButton && !isOpenChat">

    <!-- Speech Bubble Greeting removed as per user request -->

    <!-- Main Floating Action Button (Visidea Mascot Bot Icon) -->
    <div class="relative group cursor-pointer animate-float">
        <button (click)="toggleChat()" aria-label="Buka Chatbot Visidea"
            class="relative w-[150px] h-[150px] max-w-[150px] max-h-[150px] flex items-center justify-center transition-all duration-300 group-hover:scale-110 active:scale-95 cursor-pointer filter drop-shadow-xl hover:drop-shadow-2xl focus:outline-none">
            <!-- Mascot Image -->
            <img src="/assets/visidea/chatbot-avatar.png" alt="Visidea Assistant"
                class="w-[150px] h-[150px] max-w-[150px] max-h-[150px] object-contain drop-shadow-md transition-transform duration-300 group-hover:-translate-y-0.5">
        </button>
    </div>
</div>

<!-- Interactive Chatbot Window (E-Commerce Modal / Widget) -->
<div *ngIf="isOpenChat"
    class="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-[99999] w-[calc(100vw-2rem)] sm:w-[400px] h-[580px] max-h-[85vh] bg-white rounded-3xl shadow-2xl border border-slate-200/80 flex flex-col overflow-hidden font-sans animate-fade-in-up transition-all duration-300">

    <!-- Top Header -->
    <div
        class="bg-[#102B51] text-white px-4 pt-3 pb-0 flex items-center justify-between shadow-md relative overflow-hidden shrink-0">

        <div class="flex items-end gap-2.5 relative z-10 h-full">
            <!-- Bot Mascot Peeking from Bottom Border -->
            <div class="relative shrink-0 flex items-end">
                <img src="/assets/visidea/chatbot-header-avatar.png" alt="Visidea Assistant"
                    class="h-[68px] w-auto object-contain object-bottom select-none drop-shadow-md">
            </div>

            <!-- Bot Details -->
            <div class="flex flex-col pb-3">
                <div class="flex items-center gap-1.5">
                    <h3 class="font-bold text-sm tracking-wide text-white">Visidea Assistant</h3>
                </div>
                <p class="text-[11px] text-emerald-300 font-medium flex items-center gap-1 mt-0.5">
                    <span class="w-1.5 h-1.5 rounded-full bg-[#31E986] animate-pulse"></span>
                    Online
                </p>
            </div>
        </div>

        <!-- Header Actions -->
        <div class="flex items-center gap-1.5 relative z-10 pb-3">
            <!-- Reset / Restart Chat -->
            <button (click)="resetChat()" title="Mulai Ulang Chat"
                class="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 text-slate-200 hover:text-white flex items-center justify-center transition-colors cursor-pointer">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
            </button>

            <!-- WhatsApp Direct Button -->
            <button (click)="openWhatsAppDirect()" title="Hubungi WhatsApp Admin"
                class="w-8 h-8 rounded-full bg-[#25D366]/20 hover:bg-[#25D366] text-[#25D366] hover:text-white flex items-center justify-center transition-all cursor-pointer">
                <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                    <path
                        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
            </button>

            <!-- Close Chat -->
            <button (click)="closeChat()" title="Tutup Chat"
                class="w-8 h-8 rounded-full bg-white/10 hover:bg-red-500 text-slate-200 hover:text-white flex items-center justify-center transition-colors cursor-pointer">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
    </div>

    <!-- Category Filter Bar (Shopee / E-Commerce Style Topic Badges) -->
    <div
        class="bg-slate-50 border-b border-slate-200/80 px-3 py-2 flex items-center gap-1.5 overflow-x-auto no-scrollbar shrink-0">
        <button *ngFor="let cat of categories" (click)="filterCategory(cat.id)"
            [ngClass]="selectedCategory === cat.id ? 'bg-[#102B51] text-white shadow-sm' : 'bg-white text-slate-700 hover:bg-slate-100 border border-slate-200'"
            class="px-2.5 py-1 rounded-full text-[11px] font-medium whitespace-nowrap transition-all duration-200 flex items-center gap-1 cursor-pointer">
            <span>{{ cat.icon }}</span>
            <span>{{ cat.label }}</span>
        </button>
    </div>

    <!-- Messages Container -->
    <div #chatMessagesContainer class="flex-1 p-4 overflow-y-auto space-y-4 bg-slate-50/50 scroll-smooth">

        <!-- Welcome Info Banner -->
        <div class="text-center my-2">
            <span
                class="inline-block bg-slate-200/70 text-slate-600 text-[10px] px-3 py-1 rounded-full font-medium shadow-2xs">
                BOT Visidea Studio
            </span>
        </div>

        <!-- Chat History Stream -->
        <ng-container *ngFor="let msg of messages">

            <!-- Bot Message Bubble -->
            <div *ngIf="msg.sender === 'bot'" class="flex items-start gap-2.5 max-w-[88%] animate-fade-in">
                <div
                    class="w-7 h-7 rounded-full bg-[#102B51] text-white flex items-center justify-center text-xs shrink-0 shadow-sm mt-0.5 overflow-hidden p-0.5">
                    <img src="/assets/visidea/chatbot-avatar.png" alt="Bot" class="w-full h-full object-contain">
                </div>

                <div class="flex flex-col gap-2">
                    <!-- Main Text Bubble -->
                    <div
                        class="bg-white p-3.5 rounded-2xl rounded-tl-xs shadow-sm border border-slate-200/80 text-xs text-slate-800 leading-relaxed whitespace-pre-line">
                        {{ msg.text }}
                    </div>

                    <!-- Call To Action Buttons (if available) -->
                    <div *ngIf="msg.actions && msg.actions.length > 0" class="flex flex-wrap gap-1.5 mt-1">
                        <button *ngFor="let act of msg.actions" (click)="handleAction(act)"
                            [ngClass]="act.type === 'whatsapp' ? 'bg-[#25D366] hover:bg-[#20ba5a] text-white' : 'bg-[#102B51] hover:bg-[#163a6c] text-white'"
                            class="px-3 py-1.5 rounded-xl text-[11px] font-semibold flex items-center gap-1.5 shadow-sm transition-all duration-200 active:scale-95 cursor-pointer">
                            <span>{{ act.icon || '👉' }}</span>
                            <span>{{ act.label }}</span>
                        </button>
                    </div>

                    <!-- Suggested FAQ Option Chips (Clickable questions for easy follow-up) -->
                    <div *ngIf="msg.options && msg.options.length > 0" class="mt-1 flex flex-col gap-1.5">
                        <span class="text-[10px] font-semibold text-slate-400 uppercase tracking-wider">Pilihan
                            Pertanyaan Terkait:</span>
                        <div class="flex flex-col gap-1.5">
                            <button *ngFor="let opt of msg.options" (click)="selectQuestion(opt.id)"
                                class="text-left bg-emerald-50/80 hover:bg-emerald-100/90 text-emerald-900 border border-emerald-200/80 hover:border-emerald-300 p-2.5 rounded-xl text-xs font-medium transition-all duration-200 flex items-center justify-between group shadow-2xs hover:shadow-sm cursor-pointer">
                                <span class="flex items-center gap-2">
                                    <span class="text-sm">{{ opt.icon || '💬' }}</span>
                                    <span class="line-clamp-2 leading-tight">{{ opt.label }}</span>
                                </span>
                                <svg class="w-3.5 h-3.5 text-emerald-600 transition-transform group-hover:translate-x-1 shrink-0 ml-1.5"
                                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M9 5l7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <!-- Timestamp -->
                    <span class="text-[9px] text-slate-400 ml-1">
                        {{ msg.timestamp | date:'HH:mm' }}
                    </span>
                </div>
            </div>

            <!-- User Message Bubble -->
            <div *ngIf="msg.sender === 'user'"
                class="flex flex-col items-end gap-1 ml-auto max-w-[85%] animate-fade-in">
                <div
                    class="bg-gradient-to-r from-[#102B51] to-[#1e487f] text-white p-3.5 rounded-2xl rounded-tr-xs shadow-sm text-xs leading-relaxed">
                    {{ msg.text }}
                </div>
                <span class="text-[9px] text-slate-400 mr-1">
                    {{ msg.timestamp | date:'HH:mm' }} • Terkirim
                </span>
            </div>
        </ng-container>

        <!-- Quick Questions Drawer when category is selected -->
        <div *ngIf="selectedCategory !== 'all' && messages.length <= 1" class="mt-2 space-y-1.5">
            <span class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">Topik Pilihan:</span>
            <div class="flex flex-col gap-1.5">
                <button *ngFor="let item of filteredFaqs" (click)="selectQuestion(item.id)"
                    class="text-left bg-white hover:bg-slate-50 border border-slate-200 p-2.5 rounded-xl text-xs text-slate-800 font-medium transition-all duration-200 flex items-center justify-between shadow-2xs hover:shadow-sm cursor-pointer">
                    <span class="flex items-center gap-2">
                        <span>{{ item.icon || '❓' }}</span>
                        <span>{{ item.question }}</span>
                    </span>
                    <svg class="w-3.5 h-3.5 text-slate-400 shrink-0 ml-1.5" fill="none" stroke="currentColor"
                        viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                </button>
            </div>
        </div>

        <!-- Typing Animation Indicator -->
        <div *ngIf="isTyping" class="flex items-start gap-2.5 max-w-[80%] animate-fade-in">
            <div
                class="w-7 h-7 rounded-full bg-[#102B51] text-white flex items-center justify-center text-xs shrink-0 shadow-sm">
                🤖
            </div>
            <div
                class="bg-white p-3 rounded-2xl rounded-tl-xs shadow-sm border border-slate-200 text-xs text-slate-500 flex items-center gap-1.5">
                <span class="text-[11px] font-medium mr-1 text-slate-600">Visidea Bot sedang mengetik</span>
                <span class="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-bounce"></span>
                <span class="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-bounce [animation-delay:0.2s]"></span>
                <span class="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-bounce [animation-delay:0.4s]"></span>
            </div>
        </div>

    </div>

    <!-- Bottom Input & Quick Send Bar -->
    <div class="bg-white p-3 border-t border-slate-200/80 shrink-0">
        <!-- Quick Action Bar -->
        <div class="flex items-center justify-between gap-2 mb-2">
            <button (click)="resetChat()"
                class="text-[11px] text-slate-400 hover:text-slate-600 transition-colors cursor-pointer">
                Bersihkan Obrolan
            </button>
        </div>

        <!-- Text Input Form -->
        <form (ngSubmit)="sendMessage()" class="flex items-center gap-2">
            <div class="relative flex-1">
                <input type="text" name="userInput" [(ngModel)]="userInput"
                    placeholder="Ketik pertanyaan atau cari info..."
                    class="w-full bg-slate-100 text-slate-800 placeholder-slate-400 text-xs rounded-xl px-3.5 py-2.5 pr-8 border border-transparent focus:border-emerald-400 focus:bg-white focus:outline-none transition-all duration-200" />

                <button *ngIf="userInput" type="button" (click)="userInput = ''"
                    class="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 text-xs">
                    ✕
                </button>
            </div>

            <!-- Send Button -->
            <button type="submit" [disabled]="!userInput.trim()"
                [ngClass]="userInput.trim() ? 'bg-gradient-to-r from-[#102B51] to-[#31E986] text-white hover:opacity-90 active:scale-95 cursor-pointer shadow-md' : 'bg-slate-200 text-slate-400 cursor-not-allowed'"
                class="w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-200 shrink-0">
                <svg class="w-4 h-4 translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
            </button>
        </form>
    </div>

</div>